import React from "react";

const SvgSpinner = props => <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" {...props}><circle className="path" fill="none" cx={33} cy={33} r={30} /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic3Bpbm5lciIgd2lkdGg9IjY1cHgiIGhlaWdodD0iNjVweCIgdmlld0JveD0iMCAwIDY2IDY2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICA8Y2lyY2xlIGNsYXNzPSJwYXRoIiBmaWxsPSJub25lIiBjeD0iMzMiIGN5PSIzMyIgcj0iMzAiPjwvY2lyY2xlPgo8L3N2Zz4=";
export { SvgSpinner as ReactComponent };